import { Pipe, PipeTransform, inject } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

export interface CurrencyOptions {
  currency?: string;
  decimals?: number;
  sign?: boolean;
  abs?: boolean;
}

/**
 * transforms number into currency
 */
@Pipe({
  name: 'customCurrency',
  standalone: false
})
export class CustomCurrencyPipe implements PipeTransform {
  private currencyPipe = inject(CurrencyPipe);

  transform(value: any, options: CurrencyOptions = {}): any {
    if (value === null) {
      return 'N/A';
    }
    if (typeof value !== 'number') {
      return value;
    }

    const { currency = 'USD', decimals = 2, sign = false, abs = false } = options;
    const formatted =  this.currencyPipe.transform(
      abs ? Math.abs(value) : value,
      currency,
      'symbol-narrow',
      `1.${decimals}-${decimals}`,
      'en-AU',
    );

    return sign && value > 0 ? `+${formatted}` : formatted;
  }
}
